import { getAxiosInstance } from '../api.client';
import {
    type CreateCustomerUserRequest,
    type CustomerUser,
    type UpdateCustomerUserRequest,
} from './customerUsers.models';

export async function getCustomerUsers(
    customerId: string,
): Promise<CustomerUser[]> {
    const response = await getAxiosInstance().get<CustomerUser[]>(
        `/customer/${customerId}/user`,
    );
    return response.data;
}

export async function getCustomerUserById(
    customerId: string,
    id: string,
): Promise<CustomerUser> {
    const response = await getAxiosInstance().get<CustomerUser>(
        `/customer/${customerId}/user/${id}`,
    );
    return response.data;
}

export async function createCustomerUser(
    customerId: string,
    data: CreateCustomerUserRequest,
): Promise<CustomerUser> {
    const response = await getAxiosInstance().post<CustomerUser>(
        `/customer/${customerId}/user`,
        data,
    );
    return response.data;
}

export async function updateCustomerUser(
    customerId: string,
    id: string,
    data: UpdateCustomerUserRequest,
): Promise<CustomerUser> {
    const response = await getAxiosInstance().put<CustomerUser>(
        `/customer/${customerId}/user/${id}`,
        data,
    );
    return response.data;
}

export async function deleteCustomerUser(
    customerId: string,
    id: string,
): Promise<void> {
    await getAxiosInstance().delete(`/customer/${customerId}/user/${id}`);
}

export async function inviteCustomerUser(
    customerId: string,
    id: string,
): Promise<CustomerUser> {
    const response = await getAxiosInstance().post<CustomerUser>(
        `/customer/${customerId}/user/${id}/invite`,
    );
    return response.data;
}

export async function resendCustomerUserInvitation(
    customerId: string,
    id: string,
): Promise<CustomerUser> {
    const response = await getAxiosInstance().post<CustomerUser>(
        `/customer/${customerId}/user/${id}/resend-invitation`,
    );
    return response.data;
}
